import { render, staticRenderFns } from "./Delete.vue?vue&type=template&id=1422dd66&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../../../../Sites/dsgnwrks.pro/wp-content/plugins/optinmonster/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports